export default __webpack_public_path__ + "static/media/mbmi-blood.b3332104.png";